import { Container, Img, Paragraph, Span } from "../../Styles/Global.Styled";
import { css } from "styled-components";

const reviewCntStyle = css`
  flex-direction: column;
  align-items: center;
  box-shadow: 0 0 20px 0 grey;
  padding: 0 2vw 5vh 2vw;
  min-width: 40vw;
  gap: 2vh;
  border-radius: 50px;
`;
const reviewMobStyle = css`
  min-width: 85vw;
`;
const imgStyle = css`
  border: 2px solid white;
  height: 10vh;
  width: 10vh;
  margin-top: -5vh;
  border-radius: 50%;
  box-shadow: 0px 0px 20px 0px ${({ theme }) => theme.shadowColor};
`;
const textAlign = css`
  text-align: center;
`;
const cntStyle = css`
  flex-direction: column;
  align-items: center;
`;
const nameStyle = css`
  font-size: 3.5vh;
  text-align: center;
  color: ${({ theme }) => theme.main};
`;
const titleStyle = css`
  font-size: 1.75vh;
  font-weight: 600;
  text-align: center;
  color: ${({ theme }) => theme.secColor};
`;

const ClientsReview = ({ item }) => {
  return (
    <Container $baseStyle={reviewCntStyle} $mStyle={reviewMobStyle}>
      <Img $baseStyle={imgStyle} src={item.image} alt="Image" />
      <Paragraph $baseStyle={textAlign}>{item.reviewText}</Paragraph>
      <Container $baseStyle={cntStyle}>
        <Span $baseStyle={nameStyle}>{item.name}</Span>
        <Span $baseStyle={titleStyle}>{item.jobTitle}</Span>
      </Container>
    </Container>
  );
};

export default ClientsReview;
